import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core"
import { NgForm } from "@angular/forms"
import { ActivatedRoute, Params, Router } from "@angular/router"
import { Subscription } from "rxjs"
import { GTMService } from "../../../services/gtm.service"
import { SearchingService } from "../../../services/searching.service"

@Component({
    selector: "app-search-input",
    templateUrl: "./search-input.component.html",
    styleUrls: ["./search-input.component.scss"],
})
export class SearchInputComponent implements OnInit, OnDestroy {
    @ViewChild("formObj", { static: true }) public form: NgForm
    public subscriptions: Subscription[] = []

    constructor(
        private searchingService: SearchingService,
        private gtmService: GTMService,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    public ngOnInit() {
        this.subscriptions.push(
            this.route.queryParams.subscribe((queryParams: Params) => {
                if (queryParams.hasOwnProperty("q")) {
                    setTimeout(() => {
                        const value = { q: queryParams.q }
                        this.form.setValue(value)
                    })
                }
            })
        )
    }

    public onSearch(form: NgForm) {
        const queryParams = { ...form.value, page: "1" }
        this.router.navigate(["."], {
            queryParams,
            queryParamsHandling: "merge",
            relativeTo: this.route,
        })
        this.gtmService.pushEvent("search")
    }

    public ngOnDestroy() {
        this.subscriptions.map((subscription) => subscription.unsubscribe())
    }
}
